import React, { useState, useEffect } from "react";

const phoneNumber = "6287887606054";

// Kode promo global — ganti sesuai kebutuhan
const PROMO_CODE = "CORE10";

const defaultData = [
  {
    title: "BLACK ASPHALT",
    text: "Blackseal Asphalt Pro adalah pelapis anti bocor dan rembes berkualitas premium. Produk ini dirancang sebagai solusi total untuk melindungi berbagai struktur bangunan dari kerusakan akibat air dan cuaca ekstrem.\n\nFitur Utama & Keunggulan:\n• Waterproof 100%: Memberikan perlindungan mutlak terhadap air dan rembesan.\n• Daya Rekat Maksimal: Mampu melekat dengan sangat kuat dan tahan lama pada berbagai jenis permukaan.\n• Tahan Panas & Hujan: Formulasi khusus yang tangguh menghadapi perubahan cuaca ekstrem di Indonesia.\n• Fleksibel & Tidak Retak: Memiliki sifat elastis yang mengikuti pergerakan struktur.\n\nVarian Ukuran: 1 KG | 5 KG",
    image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=600&q=80",
    hargaAsli: "Rp 75.000",
    hargaPromo: "Rp 45.000",
    satuan: "/ 1 KG",
    diskon: "40%",
  },
  {
    title: "ASPAL CAIR SUPER",
    text: "Aspal Cair Super hadir dengan formula Lebih Kental untuk memberikan perlindungan maksimal pada bangunan Anda. Dirancang khusus sebagai pelapis antibocor (waterproofing) yang elastis, kuat, dan tahan lama.\n\nKeunggulan Produk:\n• Lebih Kental: Tekstur lebih pekat, menutup pori-pori dengan sempurna.\n• Daya Rekat Maksimal: Menempel kuat pada berbagai permukaan bangunan.\n• Elastis & Anti Retak: Lapisan tidak kaku sehingga tidak mudah pecah.\n• Aman untuk Kolam Ikan.\n\nPilihan Ukuran: 1 KG | 5 KG | 20 KG",
    image: "https://images.unsplash.com/photo-1587293852726-70cdb56c2866?w=600&q=80",
    hargaAsli: "Rp 97.000",
    hargaPromo: "Rp 58.000",
    satuan: "/ 1 KG",
    diskon: "40%",
  },
  {
    title: "CORMAX",
    text: "CORMAX adalah bahan tambahan (additive) beton cair yang dirancang khusus untuk meningkatkan kualitas seluruh jenis konstruksi beton.\n\nManfaat & Fungsi Utama:\n• Meningkatkan Kuat Tekan beton secara keseluruhan.\n• Meningkatkan Workability: Mempermudah proses pengerjaan beton.\n• Mengurangi Pori-Pori: Menghasilkan beton yang lebih padat dan kedap air.\n• Mencegah segregasi dan bleeding.\n\nPilihan Ukuran: 0.9 L | 5 L | 20 L",
    image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=600&q=80",
    hargaAsli: "Rp 62.000",
    hargaPromo: "Rp 37.000",
    satuan: "/ 1 KG",
    diskon: "40%",
  },
  {
    title: "BOND PRO",
    text: "Material baja struktural dengan standar SNI untuk pondasi kokoh. Dirancang untuk menahan beban berat dan tahan terhadap gempa.\n\nKeunggulan produk:\n• Tahan terhadap beban berat dan tekanan tanah\n• Tahan gempa sesuai standar SNI 1726\n• Anti korosi dengan lapisan pelindung khusus\n• Proses pemasangan cepat dan efisien\n• Tersedia dalam berbagai ukuran dan spesifikasi\n\nAplikasi: gedung bertingkat, jembatan, menara, fondasi industri berat.",
    image: "https://images.unsplash.com/photo-1565008447742-97f6f38c985c?w=600&q=80",
    hargaAsli: "Rp 950.000",
    hargaPromo: "Rp 799.000",
    satuan: "/ batang",
    diskon: "16%",
  },
];

export const Features = (props) => {
  const [selected, setSelected] = useState(null);

  const rawData = props.data && props.data.length > 0 ? props.data : defaultData;
  const data = rawData.slice(0, 4);

  useEffect(() => {
    if (selected) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [selected]);

  // Pesan WA otomatis menyebutkan kode promo — mendorong closing di luar marketplace
  const buildWaLink = (product) => {
    const msg =
      `Halo Corebuild Solution! 👋\n\n` +
      `Saya tertarik dengan produk *${product.title}*.\n\n` +
      `Saya ingin menggunakan kode promo: *${PROMO_CODE}*\n` +
      `untuk mendapatkan harga spesial *${product.hargaPromo}${product.satuan ? " " + product.satuan : ""}*.\n\n` +
      `Mohon info ketersediaan & cara pemesanannya. Terima kasih! 🙏`;
    return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(msg)}`;
  };

  const formatText = (text) =>
    text.split("\n").map((line, i) =>
      line.trim() === ""
        ? <br key={i} />
        : <span key={i} style={{ display: "block", marginBottom: "2px" }}>{line}</span>
    );

  return (
    <>
      <style>{`
        #features {
          min-height: 100vh;
          display: flex;
          align-items: center;
          background: #f3f4f6;
          padding: 60px 0;
          box-sizing: border-box;
          overflow-x: hidden;
          width: 100%;
        }
        .feat-inner {
          width: 100%;
          max-width: 1280px;
          margin: 0 auto;
          padding: 0 24px;
          box-sizing: border-box;
        }
        .feat-row {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 20px;
          align-items: stretch;
        }

        /* ── CARD ── */
        .feat-card {
          width: 100%;
          border-radius: 16px;
          overflow: hidden;
          cursor: pointer;
          position: relative;
          box-shadow: 0 8px 24px rgba(0,0,0,0.12);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          background: #fff;
          display: flex;
          flex-direction: column;
        }
        .feat-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 16px 40px rgba(0,0,0,0.2);
        }
        .feat-card-img-wrap {
          overflow: hidden;
          height: 220px;
          flex-shrink: 0;
        }
        .feat-card-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          transition: transform 0.5s ease;
        }
        .feat-card:hover .feat-card-img { transform: scale(1.07); }

        /* Badge diskon pojok kiri atas */
        .feat-badge {
          position: absolute;
          top: 12px;
          left: 12px;
          background: #ef4444;
          color: #fff;
          font-size: 11px;
          font-weight: 800;
          padding: 4px 9px;
          border-radius: 999px;
          letter-spacing: 0.5px;
          z-index: 2;
          box-shadow: 0 2px 8px rgba(239,68,68,0.45);
        }

        /* Info harga di bawah gambar */
        .feat-card-info {
          padding: 14px 14px 16px;
          display: flex;
          flex-direction: column;
          gap: 4px;
          flex: 1;
        }
        .feat-card-title {
          font-size: 13px;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 1.5px;
          color: #1f2937;
        }
        .feat-price-row {
          display: flex;
          align-items: baseline;
          gap: 7px;
          flex-wrap: wrap;
          margin-top: 5px;
        }
        .feat-price-promo {
          font-size: 16px;
          font-weight: 800;
          color: #dc2626;
        }
        .feat-price-asli {
          font-size: 12px;
          color: #9ca3af;
          text-decoration: line-through;
        }
        .feat-price-satuan {
          font-size: 11px;
          color: #6b7280;
        }
        /* Kode promo kecil di card */
        .feat-promo-chip {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          margin-top: 6px;
          background: #fffbeb;
          border: 1.5px dashed #f59e0b;
          border-radius: 6px;
          padding: 3px 8px;
          width: fit-content;
        }
        .feat-promo-chip-label { font-size: 10px; color: #92400e; }
        .feat-promo-chip-code { font-size: 11px; font-weight: 900; color: #d97706; letter-spacing: 1.5px; }

        /* ── TABLET ── */
        @media (max-width: 900px) {
          .feat-row {
            grid-template-columns: repeat(2, 1fr);
            gap: 16px;
          }
          .feat-card-img-wrap { height: 180px; }
        }

        /* ── MOBILE ── */
        @media (max-width: 480px) {
          #features { min-height: auto; padding: 48px 0; }
          .feat-inner { padding: 0 14px; }
          .feat-row {
            grid-template-columns: repeat(2, 1fr);
            gap: 10px;
          }
          .feat-card-img-wrap { height: 130px; }
          .feat-card-info { padding: 10px 10px 12px; gap: 2px; }
          .feat-card-title { font-size: 11px; letter-spacing: 1px; }
          .feat-price-promo { font-size: 13px; }
          .feat-price-asli { font-size: 10px; }
          .feat-badge { font-size: 10px; padding: 3px 7px; top: 8px; left: 8px; }
          .feat-promo-chip { padding: 2px 6px; }
          .feat-promo-chip-code { font-size: 10px; }
          .feat-promo-chip-label { font-size: 9px; }
        }

        /* === MODAL === */
        .modal-backdrop {
          position: fixed; inset: 0; z-index: 9999;
          background: rgba(0,0,0,0.65);
          display: flex; align-items: center; justify-content: center;
          padding: 20px;
          box-sizing: border-box;
          animation: fadeIn .2s ease;
        }
        .modal-box {
          background: #fff;
          border-radius: 20px;
          overflow: hidden;
          width: 100%;
          max-width: 500px;
          max-height: 92vh;
          display: flex;
          flex-direction: column;
          box-shadow: 0 24px 80px rgba(0,0,0,0.35);
          animation: slideUp .25s ease;
        }

        /* Header gambar */
        .modal-img-wrap {
          position: relative;
          flex-shrink: 0;
          height: 200px;
          overflow: hidden;
        }
        .modal-img-wrap img {
          width: 100%; height: 100%;
          object-fit: cover; display: block;
        }
        .modal-img-wrap::after {
          content: '';
          position: absolute; inset: 0;
          background: linear-gradient(to top, rgba(0,0,0,0.5) 0%, transparent 60%);
        }
        .modal-close {
          position: absolute; top: 12px; right: 12px; z-index: 3;
          background: rgba(255,255,255,0.92); border: none; border-radius: 50%;
          width: 34px; height: 34px; font-size: 20px; font-weight: bold;
          cursor: pointer; display: flex; align-items: center; justify-content: center;
          box-shadow: 0 2px 8px rgba(0,0,0,0.15);
          transition: background 0.2s;
        }
        .modal-close:hover { background: #fff; }
        .modal-title-overlay {
          position: absolute; bottom: 14px; left: 20px; z-index: 2;
          color: #fff; font-size: 20px; font-weight: 800;
          text-transform: uppercase; letter-spacing: 1px;
          text-shadow: 0 2px 8px rgba(0,0,0,0.5);
        }

        /* Harga + Kode Promo box */
        .modal-price-box {
          flex-shrink: 0;
          padding: 14px 20px 12px;
          background: #fff8f8;
          border-bottom: 1px solid #fee2e2;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 10px;
        }
        .modal-harga-promo {
          font-size: 22px;
          font-weight: 900;
          color: #dc2626;
          line-height: 1.1;
        }
        .modal-harga-satuan {
          font-size: 13px;
          font-weight: 400;
          color: #6b7280;
        }
        .modal-harga-asli {
          font-size: 13px;
          color: #9ca3af;
          text-decoration: line-through;
          margin-top: 3px;
        }
        .modal-promo-box {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          gap: 4px;
        }
        .modal-promo-label {
          font-size: 10px;
          color: #6b7280;
          text-transform: uppercase;
          letter-spacing: 1px;
          font-weight: 600;
        }
        .modal-promo-code {
          display: flex;
          align-items: center;
          gap: 6px;
          background: #fff;
          border: 2px dashed #f59e0b;
          border-radius: 10px;
          padding: 7px 14px;
        }
        .modal-promo-code-text {
          font-size: 18px;
          font-weight: 900;
          letter-spacing: 3px;
          color: #d97706;
        }
        .modal-promo-pct {
          background: #ef4444;
          color: #fff;
          font-size: 10px;
          font-weight: 800;
          padding: 2px 7px;
          border-radius: 999px;
        }

        /* Banner info cara pakai promo */
        .modal-promo-info {
          flex-shrink: 0;
          margin: 10px 20px 0;
          padding: 10px 14px;
          background: #fffbeb;
          border-left: 3px solid #f59e0b;
          border-radius: 0 8px 8px 0;
          font-size: 12px;
          color: #92400e;
          line-height: 1.6;
        }

        /* Deskripsi produk */
        .modal-body {
          flex: 1;
          overflow-y: auto;
          padding: 14px 20px 16px;
          box-sizing: border-box;
          -webkit-overflow-scrolling: touch;
        }
        .modal-body::-webkit-scrollbar { width: 4px; }
        .modal-body::-webkit-scrollbar-track { background: #f1f1f1; }
        .modal-body::-webkit-scrollbar-thumb { background: #ccc; border-radius: 4px; }
        .modal-text {
          font-size: 13.5px;
          color: #444;
          line-height: 1.85;
          white-space: pre-line;
          margin: 0;
        }

        /* Footer tombol WA */
        .modal-footer {
          flex-shrink: 0;
          padding: 14px 20px;
          border-top: 1px solid #f0f0f0;
          background: #fff;
        }
        .modal-wa-btn {
          display: flex; align-items: center; justify-content: center; gap: 10px;
          width: 100%; padding: 13px 16px; border-radius: 999px;
          background: #25D366; color: #fff; font-weight: 700;
          font-size: 14px; text-decoration: none; letter-spacing: 0.3px;
          box-sizing: border-box; transition: background 0.2s, transform 0.2s;
        }
        .modal-wa-btn:hover {
          background: #1ebe5d;
          transform: translateY(-1px);
          text-decoration: none;
          color: #fff;
        }
        .modal-wa-btn-sub {
          font-size: 11px;
          opacity: 0.85;
          font-weight: 400;
          display: block;
          margin-top: 1px;
        }
        .modal-marketplace-row {
          display: flex;
          gap: 10px;
          margin-top: 10px;
        }
        .modal-mp-btn {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 7px;
          padding: 10px 12px;
          border-radius: 999px;
          font-weight: 700;
          font-size: 13px;
          text-decoration: none;
          box-sizing: border-box;
          transition: opacity 0.2s, transform 0.2s;
        }
        .modal-mp-btn:hover {
          opacity: 0.88;
          transform: translateY(-1px);
          text-decoration: none;
        }
        .modal-mp-btn-shopee {
          background: #ee4d2d;
          color: #fff;
        }
        .modal-mp-btn-tokped {
          background: #42b549;
          color: #fff;
        }

        @media (max-width: 480px) {
          .modal-backdrop { padding: 0; align-items: flex-end; }
          .modal-box { max-height: 95vh; border-radius: 20px 20px 0 0; }
          .modal-harga-promo { font-size: 18px; }
          .modal-promo-code-text { font-size: 15px; letter-spacing: 2px; }
        }

        @keyframes slideUp {
          from { transform: translateY(30px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      `}</style>

      <div id="features">
        <div className="feat-inner">
          <div style={{ textAlign: "center", marginBottom: "48px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: 800, textTransform: "uppercase", letterSpacing: "4px", color: "#1f2937", margin: 0 }}>
              Product
            </h2>
            <h4>
              Klik Untuk Membeli
            </h4>
            <div style={{ width: "64px", height: "4px", background: "linear-gradient(to right, #60a5fa, #6366f1)", borderRadius: "999px", margin: "12px auto 0" }} />
          </div>

          <div className="feat-row">
            {data.map((d, i) => (
              <div key={i} className="feat-card" onClick={() => setSelected(d)}>
                {/* Badge diskon */}
                {d.diskon && <div className="feat-badge">HEMAT {d.diskon}</div>}

                <div className="feat-card-img-wrap">
                  <img className="feat-card-img" src={d.image} alt={d.title} />
                </div>

                <div className="feat-card-info">
                  <div className="feat-card-title">{d.title}</div>
                  {d.hargaPromo && (
                    <div className="feat-price-row">
                      <span className="feat-price-promo">{d.hargaPromo}</span>
                      {d.hargaAsli && <span className="feat-price-asli">{d.hargaAsli}</span>}
                      {d.satuan && <span className="feat-price-satuan">{d.satuan}</span>}
                    </div>
                  )}
                  {/* Chip kode promo di card */}
                  <div className="feat-promo-chip">
                    <span className="feat-promo-chip-label">Kode:</span>
                    <span className="feat-promo-chip-code">{PROMO_CODE}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* MODAL */}
      {selected && (
        <div className="modal-backdrop" onClick={() => setSelected(null)}>
          <div className="modal-box" onClick={e => e.stopPropagation()}>

            {/* Header gambar */}
            <div className="modal-img-wrap">
              <img src={selected.image} alt={selected.title} />
              <button className="modal-close" onClick={() => setSelected(null)}>×</button>
              <div className="modal-title-overlay">{selected.title}</div>
            </div>

            {/* Harga + Kode Promo */}
            {selected.hargaPromo && (
              <div className="modal-price-box">
                <div>
                  <div className="modal-harga-promo">
                    {selected.hargaPromo}
                    {selected.satuan && <span className="modal-harga-satuan"> {selected.satuan}</span>}
                  </div>
                  {selected.hargaAsli && (
                    <div className="modal-harga-asli">{selected.hargaAsli}</div>
                  )}
                </div>
                <div className="modal-promo-box">
                  <div className="modal-promo-label">Kode Promo</div>
                  <div className="modal-promo-code">
                    <span className="modal-promo-code-text">{PROMO_CODE}</span>
                    {selected.diskon && <span className="modal-promo-pct">-{selected.diskon}</span>}
                  </div>
                </div>
              </div>
            )}

            {/* Banner cara pakai promo */}
            <div className="modal-promo-info">
              🎁 Sebutkan kode <strong>{PROMO_CODE}</strong> saat chat WhatsApp untuk dapatkan harga spesial ini. Berlaku untuk pembelian langsung di luar marketplace.
            </div>

            {/* Deskripsi produk */}
            <div className="modal-body">
              <p className="modal-text">{formatText(selected.text)}</p>
            </div>

            {/* Tombol WA — pesan otomatis nyebut kode promo */}
            <div className="modal-footer">
              <a
                href={buildWaLink(selected)}
                target="_blank"
                rel="noopener noreferrer"
                className="modal-wa-btn"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="white" style={{ flexShrink: 0 }}>
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                  <span>Chat WA — Pakai Kode: {PROMO_CODE}</span>
                  <span className="modal-wa-btn-sub">Harga spesial langsung dari produsen 🔥</span>
                </div>
              </a>

              {/* Tombol Shopee & Tokopedia */}
              <div className="modal-marketplace-row">
                <a
                  href="https://id.shp.ee/ySzaV8Wg"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="modal-mp-btn modal-mp-btn-shopee"
                >
                  {/* Shopee icon SVG inline */}
                  <svg width="20" height="20" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
                    <path d="M25 2C19 2 14 6.5 13 12.5H37C36 6.5 31 2 25 2Z" fill="white"/>
                    <rect x="5" y="15" width="40" height="33" rx="5" fill="white"/>
                    <path d="M25 22c-3.5 0-6.5 2.8-6.5 6 0 2 1 3.8 2.8 4.8l5.8 3.1c1 .6 1.6 1.4 1.6 2.3 0 1.4-1.2 2.4-2.8 2.4-1.7 0-3-1.3-3-3h-4c0 3.8 3 6.5 7 6.5 3.8 0 6.8-2.8 6.8-6.2 0-2.1-1-3.8-2.8-4.9l-5.9-3.1c-1-.6-1.5-1.3-1.5-2.2 0-1.2 1.1-2.2 2.5-2.2 1.4 0 2.5 1.1 2.5 2.5h4c0-3.5-2.8-6.2-6.5-6.2z" fill="#EE4D2D"/>
                  </svg>
                  Shopee
                </a>
                <a
                  href="https://www.tokopedia.com/corebuildsolution"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="modal-mp-btn modal-mp-btn-tokped"
                >
                  {/* Tokopedia icon SVG inline */}
                  <svg width="20" height="20" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
                    <circle cx="25" cy="25" r="22" fill="white"/>
                    <path d="M25 10c-8.3 0-15 6.7-15 15 0 6 3.5 11.2 8.6 13.8l-1.4 5.2 5.7-3c.7.1 1.4.2 2.1.2 8.3 0 15-6.7 15-15S33.3 10 25 10z" fill="#42B549"/>
                    <circle cx="18" cy="26" r="2.5" fill="white"/>
                    <circle cx="25" cy="26" r="2.5" fill="white"/>
                    <circle cx="32" cy="26" r="2.5" fill="white"/>
                  </svg>
                  Tokopedia
                </a>
              </div>
            </div>

          </div>
        </div>
      )}
    </>
  );
};